import { call, put, takeLatest } from "redux-saga/effects";
import axios, { AxiosResponse } from "axios";
import request from "@util/net/request";
import { executeOnceAtATime } from "@util/net/index";
import {
  FavoritesItemActions,
  GET_FAVORITES_ITEM,
  POST_FAVORITES_ITEM,
  DELETE_FAVORITES_ITEM,
  ConfigActions
} from "@redux/reducer";
import {
  DelFavoritesItemPayload,
  FavoritesItemPayload,
  FavoritesItemResponse,
  OperateFavoritesResponse,
  PostFavoritesItemPayload
} from "@type/index";

// get favorites item list
export function* getFavoritesItemSaga(action: {
  payload: FavoritesItemPayload;
}) {
  try {
    const payload: FavoritesItemPayload = action.payload;
    yield put(FavoritesItemActions.getFavoritesItemLoading(true));
    const res: AxiosResponse<FavoritesItemResponse> = yield call(
      request.get,
      "/favorites/search",
      {
        params: {
          ids: payload.ids
        }
      }
    );
    yield put(FavoritesItemActions.getFavoritesItemSuccess(res.data.result));
  } catch (error) {
    yield put(FavoritesItemActions.getFavoritesItemLoading(false));
  }
}

// add favorites item
export function* postFavoritesItemSaga(action: {
  payload: PostFavoritesItemPayload;
}) {
  try {
    const payload: PostFavoritesItemPayload = action.payload;
    yield put(FavoritesItemActions.getFavoritesItemLoading(true));
    const res: AxiosResponse<OperateFavoritesResponse> = yield call(
      request.post,
      "/favorites",
      payload
    );
    if (res.data.status === "ok") {
      yield put(FavoritesItemActions.postFavoritesItemSuccess(payload[0].l2Id));
    }
    yield put(FavoritesItemActions.getFavoritesItemLoading(false));
  } catch (error) {
    yield put(FavoritesItemActions.getFavoritesItemLoading(false));
    if (!axios.isCancel(error)) {
      yield put(ConfigActions.setShowWishIconError(true));
    }
  }
}

// del favorites item
export function* deleteFavoritesItemSaga(action: {
  payload: DelFavoritesItemPayload;
}) {
  try {
    const payload: DelFavoritesItemPayload = action.payload;
    yield put(FavoritesItemActions.getFavoritesItemLoading(true));
    const res: AxiosResponse<OperateFavoritesResponse> = yield call(
      request.del,
      "/favorites",
      {
        params: {
          id: payload.id
        }
      }
    );
    if (res.data.status === "ok") {
      yield put(FavoritesItemActions.delFavoritesItemSuccess(payload.id));
    }
    yield put(FavoritesItemActions.getFavoritesItemLoading(false));
  } catch (error) {
    yield put(FavoritesItemActions.getFavoritesItemLoading(false));
    if (!axios.isCancel(error)) {
      yield put(ConfigActions.setShowWishIconError(true));
    }
  }
}

export const addWishlistStylingBookItem = executeOnceAtATime(
  postFavoritesItemSaga
);
export const delWishlistStylingBookItem = executeOnceAtATime(
  deleteFavoritesItemSaga
);

export function* watchLoadFavoritesItemSaga() {
  yield takeLatest<any>(GET_FAVORITES_ITEM, getFavoritesItemSaga);
  yield takeLatest<any>(POST_FAVORITES_ITEM, addWishlistStylingBookItem);
  yield takeLatest<any>(DELETE_FAVORITES_ITEM, delWishlistStylingBookItem);
}
